import { useMemo } from "react";
import { SidebarItemsType } from "../../types/sidebar";
import { hasAnyRole, getUserRoles } from "../../utils/auth";

import {
  CreditCard,
  Grid,
  DollarSign,
  Users,
  BookOpen,
  FileText,
} from "react-feather";

const allPages = [
  {
    href: "/",
    icon: Grid,
    title: "Dashboard",
  },
  /*   {
    href: "/invoices",
    icon: FileText,
    title: "Invoices",
  }, */
  {
    href: "/bills",
    icon: DollarSign,
    title: "Bills",
  },
  {
    href: "/payees",
    icon: Users,
    title: "Payees",
  },
  {
    href: "/payments",
    icon: CreditCard,
    title: "Payments",
  },
  {
    href: "/taxes2025",
    icon: FileText,
    title: "Payments 2025",
    requiredRoles: ["Admin", "Developer"],
  },
  {
    href: "/csitipalti",
    icon: BookOpen,
    title: "CSI-Tipalti Analysis",
    requiredRoles: ["Admin", "Developer"],
  },
] as SidebarItemsType[];

/* const settingSection = [
  {
    href: "/applications",
    icon: Grid,
    title: "Applications",
  },
  {
    href: "/clients",
    icon: PieChart,
    title: "Clients",
  },
  {
    href: "/programs",
    icon: List,
    title: "Programs",
  },
] as SidebarItemsType[]; */

// Hook to get filtered nav items based on user roles
export const useDashboardItems = () => {
  return useMemo(() => {
    // Get current roles to trigger re-evaluation when they change
    const userRoles = getUserRoles();

    // Filter pages based on user roles
    const pagesSection = allPages.filter((page) => {
      if (!page.requiredRoles || page.requiredRoles.length === 0) {
        return true;
      }
      const hasAccess = hasAnyRole(page.requiredRoles);

      return hasAccess;
    });

    return [
      {
        title: "Pages",
        pages: pagesSection,
      },
      /* {
        title: "Settings",
        pages: settingSection,
      }, */
    ];
  }, [getUserRoles().join(",")]); // Re-evaluate when roles change
};

// Default export for backward compatibility (but it won't be reactive)
const navItems = [
  {
    title: "Pages",
    pages: allPages.filter((page) => {
      if (!page.requiredRoles || page.requiredRoles.length === 0) {
        return true;
      }
      return hasAnyRole(page.requiredRoles);
    }),
  },
];

export default navItems;
